export { ReactComponent as HorizontalLine } from './svgs/horizontal-line.svg';
